import { Link as GatsbyLink } from "gatsby"
import PropTypes from "prop-types"
import React from "react"
import styled, { css } from "styled-components"
import { Location } from "@gatsbyjs/reach-router"

const A = styled.a``
export const Link = styled(
  ({
    underlined,
    pink,
    icon,
    iconSize,
    iconPosition,
    state,
    tabindex,
    ...props
  }) => {
    if (props.to) {
      return (
        <Location>
          {({ location }) => (
            <GatsbyLink
              data-e2e={props["data-e2e"]}
              className={props.className}
              activeClassName={props.activeClassName}
              to={props.to}
              tabIndex={tabindex}
              state={{
                prevUrl: location.href,
                prevPath: location.pathname,
                ...state,
              }}
            >
              {props.children}
            </GatsbyLink>
          )}
        </Location>
      )
    }

    return (
      <A tabindex={tabindex} key={props.key} {...props}>
        {props.children}
      </A>
    )
  }
)`
  cursor: pointer;
  text-decoration: none;

  ${props =>
    props.icon &&
    css`
      background: url("${props.icon}") left calc(50% + 1px) no-repeat;
      background-size: ${props => (props.iconSize ? props.iconSize : "20px")};

      ${props.iconPosition === "before" &&
      css`
        padding-left: ${props =>
          props.iconSize ? `calc(5px + ${props.iconSize})` : "25px"};
        background-position: left;
      `}

      ${props.iconPosition === "after" &&
      css`
        padding-right: ${props =>
          props.iconSize ? `calc(5px + ${props.iconSize})` : "25px"};
        background-position: right;
      `}
    `}

  &,
  &:hover,
  &:focus,
  &:visited {
    ${props =>
      props.underlined &&
      css`
        text-decoration: underline;
      `}

    ${props =>
      props.pink &&
      css`
        color: ${props.theme.colors.coral};
      `}
  }
`
const proptypes = {
  to: PropTypes.string,
  href: PropTypes.string,
  underlined: PropTypes.bool,
  icon: PropTypes.string,
  iconSize: PropTypes.string,
  iconPosition: PropTypes.oneOf(["before", "after"]),
  pink: PropTypes.bool,
}

Link.propTypes = proptypes
Link.defaultProps = {
  iconPosition: "before",
}

export const PinkLink = props => <Link pink {...props} />
PinkLink.propTypes = proptypes
